import subFields from '../../block/promoExplanation/inputs';
import { createInputs } from '../../utils';

export default createInputs([{ name: 'items', type: 'list', required: true, subFields }]);
